import React, { useMemo } from 'react';
import List from './List';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding';
import { KPISetUnqualified, Dashboard } from '../components';

const dataProviderName = 'opportunities/proposal';

const Default = () => {
    const { item: user } = useDataProvider('auth/token');
    const { settings, settingsLoaded, cleanFilters } = useSettingsContext(dataProviderName);

    const defaultFilters = useMemo(() => {
        const filters = { items: [] };
        if (!(user?.data?.roles ?? []).includes('Superadmin') || !settingsLoaded) {
            return filters;
        }

        const hasRegisteredAt = (cleanFilters(settings?.filterModel)?.items ?? []).some(
            (item) => item.field === 'registered_at'
        );
        if (hasRegisteredAt) {
            return filters;
        }

        const now = new Date();
        const startOfYear = new Date(`${now.getFullYear()}-01-01`);
        filters.items.push({
            field: 'registered_at',
            value: { from: startOfYear.toISOString().split('T')[0], to: now.toISOString().split('T')[0] },
            id: Math.floor(Math.random() * 5000) + 12500,
            operator: 'between',
        });
        return filters;
    }, [user, settings, settingsLoaded, cleanFilters]);
    
    return (
        <>
            {!user?.data?.roles?.includes('Superadmin') &&
                <KPISetUnqualified dataProviderName={dataProviderName} />
            }
            {user?.data?.roles?.includes('Superadmin') &&
                <Dashboard dataProviderName={dataProviderName} filters={defaultFilters} />
            }

            <List filters={defaultFilters}/>
        </>
    )
}

export default Default;


